import React, { useState } from 'react';
import Alert from './Alert';

export default function ResetPasswordModal({ user, onCancel, onConfirm }) {
  const [newPwd, setNewPwd] = useState('');
  const [confPwd, setConfPwd] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  async function handleSubmit() {
    setError('');
    if (!newPwd.trim()) {
      setError('Enter new password.');
      return;
    }
    if (newPwd.length < 4) {
      setError('Password must be at least 4 characters.');
      return;
    }
    if (newPwd !== confPwd) {
      setError('Passwords do not match.');
      return;
    }
    setSaving(true);
    try {
      await onConfirm(newPwd);
    } catch (err) {
      setError(err?.response?.data?.error || 'Failed to reset password.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div
      className="modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div className="modal" style={{ width: 400 }}>
        <div className="modal-header">
          <div className="modal-title">Reset Password — {user.name}</div>
          <button className="btn btn-sm" onClick={onCancel}>
            <i className="ti ti-x" aria-hidden="true"></i>
          </button>
        </div>
        <div className="modal-body">
          <Alert type="danger" message={error} onClose={() => setError('')} />
          <div className="form-group">
            <label className="form-label">New Password *</label>
            <input type="password" value={newPwd} onChange={(e) => setNewPwd(e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Confirm Password *</label>
            <input type="password" value={confPwd} onChange={(e) => setConfPwd(e.target.value)} />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
            <i className="ti ti-check" aria-hidden="true"></i>
            {saving ? 'Updating...' : 'Update'}
          </button>
        </div>
      </div>
    </div>
  );
}
